import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const XIcon = (props?: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="#B0B2B6"
    {...props}
  >
    <title>{props?.title}</title>
    <path d="M16.293 6.29289C16.6835 5.90237 17.3165 5.90237 17.707 6.29289C18.0975 6.68342 18.0975 7.31643 17.707 7.70696L13.414 11.9999L17.707 16.2929L17.7754 16.3691C18.0957 16.7618 18.0731 17.3408 17.707 17.707C17.3409 18.0731 16.7619 18.0957 16.3691 17.7753L16.293 17.707L12 13.414L7.70702 17.707C7.31649 18.0975 6.68348 18.0975 6.29295 17.707C5.90243 17.3164 5.90243 16.6834 6.29295 16.2929L10.5859 11.9999L6.29295 7.70696C5.90243 7.31643 5.90243 6.68342 6.29295 6.29289C6.68348 5.90237 7.31649 5.90237 7.70702 6.29289L12 10.5859L16.293 6.29289Z" />
  </svg>
)
